// docs/72 IT18–IT19 — what a hero holds in the main hand, from the SDK's item cache, so a magic
// weapon's blows can glint in its element and strike with its own sound. Read at the moment of a
// blow (no subscription of its own: the World screen already holds every item row of the World).
import { getConn } from '../net/connection';
import { catalogueItem, type CatalogueItem, type Element } from './catalogue';

/** Powers that mark a weapon as magic on the blow (AUTHORING.md: `on_hit`, `bane`, `drain`). */
const BLOW_POWERS = ['on_hit', 'bane', 'drain'];
export const isMagicWeapon = (it: CatalogueItem | undefined): boolean => !!it?.powers?.some((p) => BLOW_POWERS.some((k) => k in p));

/** The item book (`?items=1`) holds a piece in every hand it shows, with no World to read. */
let override: CatalogueItem | undefined;
export const holdForBook = (it: CatalogueItem | undefined): void => { override = it; };

/** The catalogue piece in a hero's main hand, if it is one. */
export function mainHandOf(heroId: number | bigint | undefined): CatalogueItem | undefined {
  if (override) return override;
  if (heroId === undefined) return undefined;
  const c = getConn() as unknown as { db?: { item?: { iter(): Iterable<{ heroId: bigint; equippedSlot?: number | null; def: number }> } } } | undefined;
  const rows = c?.db?.item?.iter();
  if (!rows) return undefined;
  const h = BigInt(heroId);
  for (const r of rows) if (r.heroId === h && r.equippedSlot === 0) return catalogueItem(r.def);
  return undefined;
}

/** A blow's glint: the element (and accent) of a magic weapon in the striker's hand, if any. */
export function blowGlint(it: CatalogueItem | undefined): { element: Element; accent?: Element } | undefined {
  if (!isMagicWeapon(it) || !it?.fx) return undefined;
  return it.fx.accent ? { element: it.fx.element, accent: it.fx.accent } : { element: it.fx.element };
}
